// extracted by mini-css-extract-plugin
export default {"root":"FeaturesWithTitle_root__k4zJD","title":"FeaturesWithTitle_title__LVMQQ"};